// eslint-disable-next-line react/prop-types
/* eslint-disable react/prop-types */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { Form } from 'react-bootstrap';
import { Controller, Control } from 'react-hook-form';
import Select from '../../Select';
import sellerStatus from '../../../constants/sellerStatus';
import {
    optionsTheme,
    theme,
    tradeControl,
} from '../../../styles/react-select-config';
import { IEditManyHandler } from '../../../contexts/sellersContext';
import { toast } from 'react-toastify';
import IntegratorHttpService from '../../../services/http/integrator-http';
import useSellers from '../../../hooks/useSellers';
import selectOptionValuesAsString from '../../../utils/selectOptionValuesAsString';
import selectOptionLabelsAsString from '../../../utils/selectOptionLabelsAsString';
import { EditManySellersActions } from '../../../constants/editManySeller';

interface StatusOption {
    label: string;
    value: string;
}

interface SellerStatusSelectionProps {
    control: Control;
    name?: string;
    onRef?: (handler: IEditManyHandler) => void;
}

const STATUS_OPTIONS: StatusOption[] = [
    { label: 'Ativo', value: sellerStatus.Approved },
    { label: 'Pendente', value: sellerStatus.Pending },
    { label: 'Processando', value: sellerStatus.Processing },
    { label: 'Bloqueado', value: sellerStatus.Disabled },
    { label: 'Reprovado', value: sellerStatus.Reproved },
];

const SellerStatusSelection: React.FC<SellerStatusSelectionProps> = ({
    control,
    name = 'newStatus',
    onRef,
}) => {
    const { 
        filterForm,
        actionToEditForm,
        selectedEditManyIds
    } = useSellers();
    const filterData = filterForm.watch();
    const {useFilters} = actionToEditForm.watch();
    const {
        filterTerm,
        filterAttachment,
        filterStatus,
        filterContract,
        filterComercialConsultants,
        filterCities,
        filterStates,
        filterStartDate,
        filterEndDate,
    } = filterData;

    const params = {
        term: filterTerm || '',
        ...(filterAttachment && {
            attachmentFilter: filterAttachment.value,
        }),
        ...(filterStatus?.length && {
            statusFilter: selectOptionValuesAsString(filterStatus),
        }),
        ...(filterContract?.length && {
            contractFilter: selectOptionValuesAsString(filterContract),
        }),
        ...(filterComercialConsultants?.length && {
            commercialConsultantsFilter: selectOptionValuesAsString(
                filterComercialConsultants,
            ),
        }),
        ...(filterCities?.length && {
            citiesFilter: selectOptionLabelsAsString(filterCities),
        }),
        ...(filterStates?.length && {
            statesFilter: selectOptionValuesAsString(filterStates),
        }),
        ...(filterStartDate && { startDateFilter: filterStartDate }),
        ...(filterEndDate && { endDateFilter: filterEndDate }),
    };

    useEffect(() => {
        const handler: IEditManyHandler = {
            execute: async () => {
                console.log(control.getValues()?.newStatus?.value);
                try{
                    const result = await IntegratorHttpService.updateMany({
                        filter: useFilters ? params : selectedEditManyIds,
                        newValue: control.getValues()?.newStatus?.value,
                        action: EditManySellersActions.Status
                    });

                    if (result.data){
                        toast.success('Alterações feita com sucesso');
                    }else{
                        toast.error('Houve um erro ao realizar a ação');
                    }
                } catch (err: any) {
                    toast.error(err.message);
                }
            },
        };
        onRef?.(handler);
    }, [onRef, control.getValues()?.newStatus?.value]);

    return (
        <Form.Group>
            <Form.Label>Selecione o status:</Form.Label>
            <Controller
                control={control}
                name={name}
                isClearable
                as={Select}
                options={STATUS_OPTIONS}
                styles={{
                    control: tradeControl,
                    option: optionsTheme,
                }}
                theme={theme}
                placeholder="Selecione..."
                defaultValue={null}
            />
        </Form.Group>
    );
};

export default SellerStatusSelection;
